"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const nmr_load_save_1 = require("nmr-load-save");
const react_1 = require("react");
const ChartContext_1 = require("../../context/ChartContext");
const usePanelPreferences_1 = require("../../hooks/usePanelPreferences");
const AnalysisRange_1 = __importDefault(require("./AnalysisRange"));
function MultiAnalysisRangesInner({ columns, displayerKey, activeTab, }) {
    const ranges = Object.keys(columns).filter((key) => columns[key].type !== nmr_load_save_1.AnalysisColumnsTypes.FORMULA);
    if (!ranges || ranges.length === 0) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)("g", { clipPath: `url(#${displayerKey}clip-chart-1d)`, children: ranges.map((columnKey) => ((0, jsx_runtime_1.jsx)(AnalysisRange_1.default, { columnKey: columnKey, rangeData: columns[columnKey], activeTab: activeTab }, columnKey))) }));
}
const MemoizedMultiAnalysisRanges = (0, react_1.memo)(MultiAnalysisRangesInner);
function MultiAnalysisRanges() {
    const { view: { spectra: { activeTab }, }, displayerKey, } = (0, ChartContext_1.useChartData)();
    const multipleSpectraAnalysis = (0, usePanelPreferences_1.usePanelPreferences)('multipleSpectraAnalysis', activeTab);
    const columns = multipleSpectraAnalysis.analysisOptions.columns;
    return ((0, jsx_runtime_1.jsx)(MemoizedMultiAnalysisRanges, { columns, displayerKey, activeTab }));
}
exports.default = MultiAnalysisRanges;
